import * as React from 'react'

function IconDownloadDisabled(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={96}
      height={90}
      viewBox="0 0 96 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M88.82 32.98v25.73c0 13.34-10.81 24.15-24.15 24.15H30.65C17.31 82.86 6.5 72.04 6.5 58.71V32.98M47.66 6.5v45.36"
        stroke="#C4C4C4"
        strokeWidth={13}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M28.84 42.95L41.3 57.46c3.35 3.9 9.38 3.9 12.73 0l12.46-14.51"
        stroke="#C4C4C4"
        strokeWidth={13}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default IconDownloadDisabled
